import { render, staticRenderFns } from "./Broadcaster.vue?vue&type=template&id=b5209090&scoped=true"
import script from "./Broadcaster.vue?vue&type=script&lang=js"
export * from "./Broadcaster.vue?vue&type=script&lang=js"
import style0 from "./Broadcaster.vue?vue&type=style&index=0&id=b5209090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5209090",
  null
  
)

export default component.exports